<template>
  <div class="navbar-fixed-content" style="padding-top:70px;">
    <my-account-header></my-account-header>
    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>

        <div class="myinfo-con">
          <div class="tabbable-line">
            <ul class="nav nav-tabs">
              <li :class="[showMyQuestions?'active':'']">
                <a
                  class="a-tab"
                  data-status="1"
                  data-toggle="tab"
                  id="li_2_1"
                  aria-expanded="true"
                  @click="questionClick"
                >我的问答</a>
              </li>
              <li :class="[showMyQuestions?'':'active']">
                <a
                  class="a-tab"
                  data-status="2"
                  data-toggle="tab"
                  id="li_2_2"
                  aria-expanded="false"
                  @click="answerClick"
                >我的评论</a>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div id="tab_2_1" :class="[showMyQuestions? 'tab-pane active' : 'tab-pane']">
              <div class="plList">
                <div
                  class="qitem type-q"
                  v-show="questionShow"
                  v-for="questionItems in questionsLists"
                  :key="questionItems"
                  @click="childQuestionsClick(questionItems)"
                >
                  <div class="uft">
                    <img :src="questionItems.headImg" class="h_img" />
                    <span class="u-name" data-id="14">{{questionItems.userName}}</span>
                  </div>

                  <div class="urt">
                    <div class="pretxt">
                      <span class="comtxt">{{questionItems.comments}}</span>
                    </div>
                    <span class="num">
                      <span>{{questionItems.reviewState}}回答</span>
                    </span>
                    <span class="viewcount">{{questionItems.viewsCount}}浏览</span>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-12 loading-more"
                    v-if="this.query_data[0].PageIndex*this.query_data[0].MaxResultCount< this.query_data[0].totalCount"
                    @click="loadMoreQuestions()"
                  >加载更多</div>
                </div>
                <div v-show="!questionShow">
                  <div class="div1">
                    <span>问答评论</span> &gt;
                    <a class="allquestion" @click="allQuestions()">全部</a> &gt;
                    <a>{{questionItem.comments}}</a>
                  </div>
                  <div class="plInfo">
                    <h2>问答</h2>
                    <div class="qitem2">
                      <div class="uft">
                        <img :src="questionItem.headImg" class="h_img" />
                        <span class="u-name">{{questionItem.userName}}</span>
                      </div>
                      <div class="urt">
                        <div class="pretxt">
                          <span class="comtxt">{{questionItem.comments}}</span>
                        </div>
                        <span class="num">
                          <span>{{questionItem.reviewState}}回答</span>
                          <span class="viewcount">{{questionItem.viewsCount}}浏览</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="replylist">
                    <div
                      :class="[childItem.isAdoption ? 'ritem Adoption' : 'ritem']"
                      v-for="childItem in childQuestionsLists"
                      :key="childItem.id"
                    >
                      <span class="uinfo">
                        <img :src="childItem.headImg" />
                        <span class="uname">{{childItem.replyToUserName}}</span>
                      </span>
                      <span class="comtxt">{{childItem.comments}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab_2_2" :class="[showMyQuestions? 'tab-pane' : 'tab-pane active']">
              <div class="plList">
                <div class="qitem2 type-p" data-q-id="{qid}" v-for="answerItems in answersLists">
                  <div class="uft">
                    <img :src="answerItems.user.headImage" class="h_img" />
                  </div>
                  <div class="urt">
                    <div class="pretxt">
                      <span
                        class="u-name"
                        style="margin-bottom: 10px;"
                      >{{answerItems.user.fullName}}</span>
                      <span class="comtxt">{{answerItems.content}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 loading-more"
                style="with:100%,height:50px"
                v-if="this.query_data[1].PageIndex*this.query_data[1].MaxResultCount< this.query_data[1].totalCount"
                @click="loadMoreAnswers()"
              >加载更多</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import comFun from "@/common/common";
export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    return {
      query_data: [
        {
          stopajax: !1,
          MaxResultCount: 10,
          PageIndex: 0,
          SkipCount: 0,
          totalCount: 0,
          index: 0,
        }, //问答
        {
          stopajax: !1,
          MaxResultCount: 10,
          PageIndex: 0,
          SkipCount: 0,
          totalCount: 0,
          index: 0,
        }, //评论
      ],
      // headImg:'',
      //   userName: '',
      //   comments: '',
      //   reviewState: '',
      //   viewCount: '',
      questionShow: true,
      questionItem: {},
      childQuestionsLists: [],
      questionsLists: [],
      answersLists: [],
      showMyQuestions: true,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
  // created() {
  //   this.getMyCourseList(this.query_data).then(res=>{ this.courseLists = res.items});
  // },
  mounted() {
    this.loadMoreQuestions();
    this.loadMoreAnswers();
  },
  methods: {
    loadMoreQuestions: function () {
      comFun.getMyQuesitionsList(this.query_data[0]).then((res) => {
        this.questionsLists = this.questionsLists.concat(res.items);
        this.query_data[0].totalCount = res.totalCount;
        if (
          this.query_data[0].PageIndex * this.query_data[0].MaxResultCount <
          this.query_data[0].totalCount
        ) {
          this.query_data[0].PageIndex++;
        } else {
          this.query_data[0].stopajax = 1;
        }
      });
    },
    loadMoreAnswers: function () {
      comFun.getMyAnswersList(this.query_data[1]).then((res) => {
        this.answersLists = this.answersLists.concat(res.items);
        this.query_data[1].totalCount = res.totalCount;
        if (
          this.query_data[1].PageIndex * this.query_data[1].MaxResultCount <
          this.query_data[1].totalCount
        ) {
          this.query_data[1].PageIndex = this.query_data[1].PageIndex + 1;
        } else {
          this.query_data[1].stopajax = 1;
        }
      });
    },
    questionClick: function () {
      this.showMyQuestions = true;
    },
    answerClick: function () {
      this.showMyQuestions = false;
    },
    childQuestionsClick(item) {
      this.questionItem = item;

      comFun.getChildQuestions(item.id).then((res) => {
        this.childQuestionsLists = res;
        this.questionShow = !this.questionShow;
      });
    },
    allQuestions() {
      this.questionShow = !this.questionShow;
    }
  },
};
</script>